import { CoursePlayerScreen } from '@/screens/courses-screen/CoursePlayerScreen'

export default function CoursePlayerRoute() {
  return <CoursePlayerScreen />
}
